import { render } from "./DashboardContainer.vue?vue&type=template&id=3770c0dc&scoped=true"
import script from "./DashboardContainer.vue?vue&type=script&lang=js"
export * from "./DashboardContainer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3770c0dc"

export default script